export default __webpack_public_path__ + "static/media/24_hours_support.6b29677d.svg";